"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _AttachmentsListModule = _interopRequireDefault(require("./AttachmentsList.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const formatFileSize = bytes => {
  const kb = Math.round(bytes / 1024);
  return `${kb} KB`;
};
const AttachmentsList = _ref => {
  let {
    attachments,
    removeAttachment
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: _AttachmentsListModule.default.attachmentsList
  }, attachments.map(item => /*#__PURE__*/_react.default.createElement("li", {
    key: item.file.name + item.file.size,
    className: _AttachmentsListModule.default.attachmentItem
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: _AttachmentsListModule.default.attachmentName,
    variant: "body4",
    fontFamily: "mono"
  }, item.file.name), /*#__PURE__*/_react.default.createElement("p", {
    className: _AttachmentsListModule.default.attachmentSize,
    variant: "body4",
    fontFamily: "mono"
  }, "(", formatFileSize(item.file.size), ")"), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: _AttachmentsListModule.default.attachmentRemove,
    onClick: event => {
      event.stopPropagation();
      removeAttachment(item.id);
    },
    "aria-label": `Remove ${item.file.name}`
  }, /*#__PURE__*/_react.default.createElement(_Close.default, {
    fontSize: "small"
  })))));
};
var _default = exports.default = AttachmentsList;